<template>
  <div class="header">
    <div class="fl huanying">
      欢迎登陆石家庄市残疾人联合会官方网站！
      <p>
        <a href="#" title="欢迎登陆石家庄市残疾人联合会官方网站！">欢迎登陆石家庄市残疾人联合会官方网站！</a>
      </p>
    </div>
    <div class="fr fr1">
      <a href="/" title="首页" style="font-weight:bold;" accesskey="x">首页</a>&nbsp;|&nbsp;
      <a
        href="/page?classId=651123031580"
        title="无障碍声明"
        style="font-weight:bold;"
        accesskey="x"
      >无障碍声明</a>&nbsp;|&nbsp;
      <a
        href="http://www.cdpf.org.cn/bbtt/"
        title="“邦邦听图”客户端下载"
        style="font-weight:bold;"
        target="_blank"
      >“邦邦听图”客户端下载</a>&nbsp;|&nbsp;
      <a href="#" id="based" ref="jianfan" @click="StranBody" title="點擊以繁體中文方式浏覽">繁體中文</a>
      <div id="wazA" class="wazA">
        <router-link :to="'/wza'">
          <a title="开启无障碍浏览">开启无障碍浏览</a>
        </router-link>
      </div>
    </div>
    <div
      id="yx_mousefollow_y"
      style="display: none; position: absolute; left: 0; top: 0px;
            z-index: 12000; width: 100%; height: 6px; font-size: 6px; background-color: Red;"
    ></div>

    <div
      id="yx_mousefollow_x"
      style="display: none; position: absolute; left: 0; top: 0px;
            z-index: 12001; width: 6px; height: 100%; font-size: 6px; background-color: Red;"
    ></div>
  </div>
</template>

<script>
import { StranBody } from "../../static/js/janfan";
import router from "../router";
import {
  wzaToolSpeakOnOff,
  hideSpeech,
  wzaToolBatchRead,
  wzaToolPointread,
  speakSpeed
} from "../assets/wza/js/speak";
export default {
  name: "Header",
  props: {
    bg_color: {
      type: String,
      default: "transparent"
    },
    hd_position: {
      type: String,
      default: "fixed"
    },
    hover_flag: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    IsNone() {
      return function(e) {
        return e.child.length > 0 ? "" : "disabled";
      };
    }
  },
  methods: {
    // open() {
    // //   console.log(1);
    //   var statuspointread = (this.$store.state.speak.statuspointread = "on");
    //   wzaToolPointread(this.$store, statuspointread);
    // },
    StranBody: function() {
      StranBody();
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  display: block;
}
.header .huanying {
  margin-left: 1px;
  line-height: 32px;
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.header {
  width: 100%;
  height: 28px;
  line-height: 32px;
  color: #fff;
  overflow: hidden;
}
.fr1 a {
  color: #fff;
}
.wazA {
  background-color: rgb(247, 31, 31);
  font-size: 14px;
  float: right;
  margin: 0 6px 0 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue